/**
 * @fileoverview Provider icon resolution utility.
 * @module features/settings/components/integration-shared/getProviderIcon
 */

import type { ReactElement } from 'react'
import { Plug, Landmark } from 'lucide-react'
import { cn } from '@/shared/utils/cn'
import type { IntegrationProvider } from '../../schemas/integrationStatusSchema'
import { PROVIDER_ICONS } from './constants'

/**
 * Returns the icon component for a provider.
 */
export function getProviderIcon(provider: IntegrationProvider, className = 'size-5'): ReactElement {
  switch (provider) {
    case 'FACEBOOK':
      return <img src={PROVIDER_ICONS.FACEBOOK} alt="Facebook Ads" className={className} />
    case 'GOOGLE_ADS':
      return <img src={PROVIDER_ICONS.GOOGLE_ADS} alt="Google Ads" className={className} />
    case 'BASELINKER':
      return <img src={PROVIDER_ICONS.BASELINKER} alt="BaseLinker" className={className} />
    case 'SHOPIFY':
      return <img src={PROVIDER_ICONS.SHOPIFY} alt="Shopify" className={className} />
    case 'BANK':
      return <Landmark className={cn(className, 'text-muted-foreground')} />
    default:
      return <Plug className={className} />
  }
}
